import Form from '../../app-components/form/Form';
import {submit} from '../../AppServices';
import {PLACEHOLDER} from '../../app-components/utils';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';

export default ({uri, header}) => {
  const SurgicalHistoryForm = Form({
    type: 'standardShadow',
    onSubmit: submit({
      model: 'SurgicalHistories',
    }),
    uri,
    closeView: 1,
    reloadEvent: 'reloadSurgicalHistory',
    mandatory: {name: 1},
    lg: {
      header,
      formGroups: [
        {
          columnsPerRow: 1,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  mandatory: true,
                  placeholder: PLACEHOLDER,
                  label: 'Surgical History Name',
                  width: '50%',
                },
              ],
            },
          ],
        },
      ],
    },
    sm: {
      header: {
        title: header.title,
      },
      footer: {
        actions: [cancelButton(), save()],
      },
      formGroups: [
        {
          columnsPerRow: 1,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  mandatory: true,
                  placeholder: PLACEHOLDER,
                  label: 'Surgical Histories Name',
                },
              ],
            },
          ],
        },
      ],
    },
  });
  return SurgicalHistoryForm;
};
